import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const deleteCompanyMember = (axios: IAxiosInstance) => {
  return async (companyID: string, memberID: string): Promise<void> => {
    const response = await axios.noRetry.delete<IApiResponse<null>>(
      `/api/companies/${companyID}/members/${memberID}`
    );
    const data = response.data;

    if (data.success) {
      return;
    }

    throw new Error("Failed to remove company member");
  };
};
